(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["apprating"] && !window.DesignMode) return;
  try {
    


  (function() {
  
      $('.ratingslider__slick').slick({
      infinite: true,
      dots: true,
      centerMode: true,
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            centerMode: false,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            speed: 200
          }
        }
      ]
    });
  })();
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp_02_product_slider"]) return;
  try {
    
  
  (function() {

      $('.pdp-stage__slider').slick({
      infinite: true,
      dots: true,
      arrows: true,
      fade: true,
      autoplay: false,
      autoplaySpeed: 4000,
      speed: 800,
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            fade: false,
            lazyLoad: 'ondemand',
            autoplay: false,
            speed: 300,
            arrows: true,
            dots: false,
          }
        }
      ]
    });

  })();
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp_03_product_slider"]) return;
  try {
    
  
  (function() {

      $('.pdp-stage__slider').slick({
      infinite: true,
      dots: true,
      arrows: true,
      fade: true,
      autoplay: false,
      autoplaySpeed: 4000,
      speed: 800,
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            fade: false,
            lazyLoad: 'ondemand',
            autoplay: false,
            speed: 300,
            arrows: true,
            dots: false,
          }
        }
      ]
    });

  })();
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp_04_product_slider"]) return;
  try {
    
  
  (function() {

      $('.pdp-stage__slider').slick({
      infinite: true,
      dots: true,
      arrows: true,
      fade: true,
      autoplay: false,
      autoplaySpeed: 4000,
      speed: 800,
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            fade: false,
            lazyLoad: 'ondemand',
            autoplay: false,
            speed: 300,
            arrows: true,
            dots: false,
          }
        }
      ]
    });

  })();
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp_05_product_slider"]) return;
  try {
    
  
  (function() {

      $('.pdp-stage__slider').slick({
      infinite: true,
      dots: true,
      arrows: true,
      fade: true,
      autoplay: false,
      autoplaySpeed: 4000,
      speed: 800,
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            fade: false,
            lazyLoad: 'ondemand',
            autoplay: false,
            speed: 300,
            arrows: true,
            dots: false,
          }
        }
      ]
    });

  })();
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp_closeups"]) return;
  try {
    
	
	
	(function() {
	   	$('.closeupslider__slick-images').slick({
		  infinite: true,
		  dots: false,
		  centerMode: true,
		  lazyLoad: 'ondemand',
		  arrows: true,
		  slidesToShow: 3,
		  slidesToScroll: 1,
	      asNavFor: '.closeupslider__slick-text',
		  responsive: [
		    {
		      breakpoint: 600,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1,
		        centerMode: true
		      }
		    }
		  ]
		});

		$('.closeupslider__slick-text').slick({
		  asNavFor: '.closeupslider__slick-images',
		  infinite: true,
		  dots: true,
		  fade: true,
		  centerMode: false,
		  arrows: false,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		});
	})();
  	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp_product_slider"]) return;
  try {
    
  
  (function() {
      $('.pdp-stage__slider').slick({
      infinite: true,
      dots: true,
      arrows: true,
      fade: true,
      autoplay: false,
      autoplaySpeed: 4000,
      speed: 800,
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            fade: false,
            lazyLoad: 'ondemand',
            autoplay: false,
            speed: 300,
            arrows: true,
            dots: false,
          }
        }
      ]
    });


    if(windowWidth > 699){
     $('.pdp-stage__slider__item__img')
      .wrap('<span style="display:inline-block"></span>')
      .css('display', 'block')
      .parent()
      .zoom({
        url: $(this).find('img').attr('data-zoom')
      });
    } else{

    }

  })();
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press"] && !window.DesignMode) return;
  try {
    
	
	(function() {
	   	$('.pressslider__slick').slick({
		  infinite: true,
		  dots: true,
		  centerMode: true,
		  lazyLoad: 'ondemand',
		  arrows: false,
		  slidesToShow: 3,
		  slidesToScroll: 1,
		  responsive: [
		    {
		      breakpoint: 1000,
		      settings: {
		      	centerMode: false,
		        slidesToShow: 2,
		        slidesToScroll: 1
		      }
		    },
		    {
		      breakpoint: 600,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1,
		        autoplay: false,
            	speed: 200,
		        infinite: false
		      }
		    }
		  ]
		});
	})();
  	

  } catch(e) { console.error(e); }
})();

})();
